<h2 mat-dialog-title>Select</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>Selection</mat-label>
    <input matInput type="number" min="0" max="99" [(ngModel)]="value" required>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="value" [disabled]="value === undefined || value < 0 || value > 99">OK</button>
</mat-dialog-actions>
